
const PAGES = {
	tutorial: 'https://api.cosmicjs.com/v1/mangooid/object/tutorial?pretty=true'
};





class CMS {

	constructor ($http) {
		this.$http = $http;
	}

	get (page) {
		var pageUrl = PAGES[page];

		if (!pageUrl) {
			return Promise.reject('Page does not exists');
		}

		return this.$http({
			method: 'get',
			url: pageUrl
		})
		.then(processEnvelope.bind(this))
		.then(processContent.bind(this))
		;
	}

}

CMS.$inject = ['$http'];

export default angular.module('service.cms', [])
	.service('CMS', CMS)
	.name;






/*
 * Process response
 */
function processEnvelope (response) {
	return response.data;
}

function processContent (response) {
	return response.object.content;
}



// WEBPACK FOOTER //
// ./src/service/cms.js